
import { SidebarProvider, SidebarInset, SidebarTrigger, useSidebar } from '@/components/ui/sidebar';
import { Button } from '@/components/ui/button';
import AppSidebar from '@/components/AppSidebar';
// Removed TutorConsentGuard - now handled by UnifiedConsentGuard in App.tsx
import { useAuth } from '@/hooks/useAuth';
import { Calendar } from 'lucide-react';
import { useState } from 'react';
import BookingsModal from '@/components/BookingsModal';
import MessagesDropdown from '@/components/MessagesDropdown';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayoutContent = ({ children }: DashboardLayoutProps) => {
  const { user } = useAuth();
  const { toggleSidebar } = useSidebar();
  const [isBookingsModalOpen, setIsBookingsModalOpen] = useState(false);

  return (
    <div className="min-h-screen flex w-full overflow-x-hidden">
      <AppSidebar />
      <SidebarInset className="flex-1 min-w-0">
        <header className="flex h-12 md:h-16 shrink-0 items-center gap-2 border-b px-3 md:px-4 bg-white fixed md:sticky top-0 left-0 right-0 z-50 min-w-0">
          <SidebarTrigger className="-ml-1 h-10 w-16 md:h-12 md:w-20 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-lg rounded-lg font-semibold text-sm md:text-base transition-all duration-200 flex items-center justify-center shrink-0" />
          <span 
            className="text-sm md:text-base font-bold text-blue-600 ml-2 block md:hidden lg:block whitespace-nowrap cursor-pointer hover:text-blue-800 transition-colors"
            onClick={toggleSidebar}
          >
            MENU
          </span>
          <div className="flex-1 min-w-0" />
          <div className="flex items-center gap-1 md:gap-2 shrink-0">
            {/* Messages Dropdown */}
            <MessagesDropdown 
              buttonClassName="relative h-10 w-10 md:h-12 md:w-12 p-1 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white shrink-0 rounded-lg shadow-md hover:shadow-lg transition-all duration-200"
            />

            {/* Bookings Button */}
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsBookingsModalOpen(true)}
              className="h-10 w-10 md:h-12 md:w-12 p-1 bg-gradient-to-r from-violet-500 to-violet-600 hover:from-violet-600 hover:to-violet-700 text-white shrink-0 rounded-lg shadow-md hover:shadow-lg transition-all duration-200"
              title="Bookings"
            >
              <Calendar className="h-5 w-5 md:h-6 md:w-6" />
            </Button>
          </div>
        </header>
        <main className="flex-1 bg-gray-50/50 w-full min-w-0 overflow-x-hidden pt-12 md:pt-0">
          <div className="min-h-[calc(100vh-3rem)] md:min-h-[calc(100vh-4rem)] w-full">
            {children}
          </div>
        </main>
      </SidebarInset>
      
      {/* Bookings Modal */}
      <BookingsModal 
        isOpen={isBookingsModalOpen}
        onClose={() => setIsBookingsModalOpen(false)}
      />
    </div>
  );
};

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  return (
    <SidebarProvider>
      <DashboardLayoutContent>{children}</DashboardLayoutContent>
    </SidebarProvider>
  );
};

export default DashboardLayout;
